import { render, staticRenderFns } from "./CausalItemOutput.vue?vue&type=template&id=0e4b8ec5&scoped=true&"
import script from "./CausalItemOutput.vue?vue&type=script&lang=ts&"
export * from "./CausalItemOutput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4b8ec5",
  null
  
)

export default component.exports